import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";
import bgImage from "@assets/images/bg-image.jpg";

const TermAndConditionStyle = makeStyles((theme) => ({
  customSelect: {
    display: "block",
  },
  title: {
    fontWeight: "bold",
    color: "#0f95f3",
    fontSize: theme.typography.pxToRem(20),
  },
  terms: {
    fontWeight: "bold",
    marginTop: theme.spacing(2),
  },
  subTitle: {
    fontWeight: "bold",
    color: "#7e7e81",
    marginBottom: "5px",
  },
  itemTitle: {
    fontWeight: 600,
    marginTop: "15px",
  },
  content: {
    overflow: "hidden",
    height: "43vh",
    // padding: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      height: "32vh",
      overflow: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      height: "22vh",
    },
  },
  contentWrapper: {
    background: "white",
    width: "60%",
    padding: "35px 50px",
    borderRadius: "6px",
    overflowY: "hidden",
    [theme.breakpoints.down("xl")]: {
      width: "75%",
      padding: "25px 30px",
    },
    [theme.breakpoints.down("lg")]: {
      width: "70%",
      padding: "25px 30px",
    },
    [theme.breakpoints.down("md")]: {
      width: "90%",
      maxHeight: "60%",
      padding: "25px 30px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "95%",
      padding: "20px",
    },
    "&::-webkit-scrollbar": {
      width: 8,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
      borderRadius: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: "6px",
    },
  },
  actions: {
    textAlign: "end",
  },
  exploreButton: {
    marginLeft: "auto",
    background: colors.primary,
    color: colors.white,
    "&:hover": {
      background: colors.orange
    }
  },
  commonBannerWrapper: {
    "& .MuiBackdrop-root": {
      color: "#fff",
      zIndex: "1201",
    },
    "& .commonBanner": {
      backgroundImage: `url(${bgImage})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "bottom",
      height: "100vh",
      overflow: "hidden",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      [theme.breakpoints.down("lg")]: {
        backgroundPosition: "bottom",
      },
      "@media (max-height: 550px)": {
        minHeight: 600,
      },
    },
    "& .custom-form": {
      "& .btn-wrapper": {
        marginTop: "35px",
        "& button": {
          width: "100%",
          height: "50px",
          lineHeight: "50px",
          fontSize: "16px",
          fontWeight: "600",
          textTransform: "uppercase",
        },
        "& .label-text": {
          marginTop: "15px",
        },
      },
    },
  },
}));

export { TermAndConditionStyle };
